import React from "react";
import { TableCellRenderer } from "react-table";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { Text } from "src/library/components/Text";

export interface UserGroupTableProps {
  ActionButton?: TableCellRenderer;
}

/**
 * user group table columns
 */
export const userGroupTableColumns = (params: UserGroupTableProps): CustomTableColumn[] => {
  const promotionColumnsAdmin: CustomTableColumn[] = [
    globalTableColumns.id(),
    globalTableColumns.standardText({
      Header: "Name",
      accessor: "name"
    }),
    globalTableColumns.standardText({
      Header: "Manager",
      accessor: "manager",
      filterable: false,
      Cell: row => (
        <Text>
          {row.original.manager ? `${row.original.manager.firstName} ${row.original.manager.lastName}` : "-"}
        </Text>
      )
    }),
    globalTableColumns.actions({ cell: params.ActionButton })
  ];

  return promotionColumnsAdmin;
};
